import { render, staticRenderFns } from "./SendMailHistory.vue?vue&type=template&id=0513cd22&"
import script from "./SendMailHistory.vue?vue&type=script&lang=js&"
export * from "./SendMailHistory.vue?vue&type=script&lang=js&"
import style0 from "./SendMailHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SendMailHistory.vue"
export default component.exports